import styled, { css } from "styled-components"
import { displays } from "theme/base/Variables"

interface ContractorSummaryProductCardProps {
  hasIcon?: boolean;
  isConfirm?: boolean;
  isQuantityComplete?: boolean;
}

const ContractorSummaryProductCardStyled = styled.article<ContractorSummaryProductCardProps>`
  padding: 1rem 0.5rem;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.06);
  border-left: 4px solid ${({ isQuantityComplete }) => isQuantityComplete ? '#28a745' : '#ffc107'};

  & .item-name {
    color: ${({ theme }) => theme.palette.grey90};
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    padding: 0.75rem 1rem;
    background: ${({ theme }) => theme.palette.grey5};
    border: 1px solid ${({ theme }) => theme.palette.grey20};
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    position: relative;
    transition: all 0.3s ease;
    
    
    &:hover {
      background: ${({ theme }) => theme.palette.grey10};
      border-color: ${({ theme }) => theme.palette.grey30};
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    }
  }

  & .body-product-card {
    ${displays.flexBetween};

    & .info-tem {
      & > p {
        ${displays.flexBase};
        gap: 0.3rem;
        margin: 0.2rem 0;
        color: ${({ theme }) => theme.palette.grey60};
        & span {
          &.order-id {
            color: ${({ theme }) => theme.palette.blueDark};
          }
        }
      }
    }

    ${({ hasIcon, isConfirm, theme }) =>
      hasIcon &&
      css`
        & > svg {
          font-size: 3rem;
          color: ${isConfirm
            ? theme.alert.success.backgroundColor
            : theme.alert.danger.backgroundColor};
        }
      `}
  }
`

export default ContractorSummaryProductCardStyled
